import { Box } from "@mui/material";

const DragDropIndicator = () => <Box display="flex" alignItems="center">
  <Box sx={{ width: "6px", height: "6px", border: "2px solid #1D4ED8", borderRadius: "50%" }} />
  <Box sx={{ backgroundColor: "#1D4ED8", border: "2px solid #1D4ED8", pointerEvents: "none", height: "2px", width: "calc(100% - 6px)" }} />
</Box >;

export default DragDropIndicator;